<script>
import NextButton from 'dashboard/components-next/button/Button.vue';
import EmptyState from '../../../../components/widgets/EmptyState.vue';

export default {
  components: {
    NextButton,
    EmptyState,
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <EmptyState
      :title="$t('BRANCHES_SETTINGS.FINISH.TITLE')"
      :message="$t('BRANCHES_SETTINGS.FINISH.MESSAGE')"
    >
      <div class="w-full text-center">
        <router-link
          :to="{
            name: 'settings_branches_list',
          }"
        >
          <NextButton
            teal
            :label="$t('BRANCHES_SETTINGS.FINISH.BUTTON_TEXT')"
          />
        </router-link>
      </div>
    </EmptyState>
  </div>
</template>
